// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"dacbe496","488":"83a235e7"}[chunkId] + ".chunk.js";
};